import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

try {
  if (process.env.GATSBY_LOGROCKET_API_KEY) {
    LogRocket.init(process.env.GATSBY_LOGROCKET_API_KEY);
    setupLogRocketReact(LogRocket);
  } else {
    console.warn('LogRocket API key not found');
  }
} catch (error) {
  console.warn('Error initializing LogRocket:', error);
}

export default LogRocket;
